import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';

@Component({
  selector: 'px-mel-link',
  host: {
    class: 'flex flex-row justify-start items-center gap-x-1'
  },
  template: `
    @if (organizationSelectors.usesMEL | select) {
      <p class="text-body-large hidden md:block">{{ introText }}</p>
      <mx-text-button label="Check MeLCat" href="https://elibrary.mel.org/"/>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, TextButtonComponent]
})
export class MelLinkComponent {

  @Input() public introText: string = '';

  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
